import React, { type ReactNode } from 'react';

import IconClose from '@pkg/assets/icons/close.svg?react';
import { type CommonActionProps } from '@pkg/primitives';

import { Action, IconWrapper, Label } from './FilterAction.style.ts';

export interface FilterActionProps {
    label?: string;
    icon?: ReactNode;
    ariaLabel?: string;
    iconOnly?: boolean;
    disabled?: boolean;
    pressed?: boolean;
    children?: ReactNode;
    onAction?: CommonActionProps['onAction'];
}

export function FilterAction({
    label = 'Filter',
    icon,
    ariaLabel,
    iconOnly = false,
    disabled = false,
    pressed = false,
    children,
    onAction,
}: FilterActionProps) {
    const iconMarkup = icon ? <IconWrapper>{icon}</IconWrapper> : null;

    const fallbackIconMarkup =
        iconOnly && !iconMarkup ? (
            <IconWrapper>
                <IconClose />
            </IconWrapper>
        ) : null;

    const labelMarkup = iconOnly ? null : <Label>{label}</Label>;

    return (
        <Action $iconOnly={iconOnly} ariaLabel={ariaLabel} disabled={disabled} pressed={pressed} onAction={onAction}>
            {iconMarkup || fallbackIconMarkup}
            {labelMarkup}
            {iconOnly ? null : children}
        </Action>
    );
}
